import React, { ChangeEvent, useRef } from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { formatPrice } from 'utils/helpers';
import { LineItem } from 'utils/types';
import * as S from './styles';
import { useCartImage } from 'utils/hooks';

type Props = {
  product: LineItem;
  removeProduct: Function;
  changeProductQuantity: Function;
};

const CartProduct = (props: Props) => {
  const currentProduct = props.product;
  const { removeProduct } = props;

  const productImage = useRef<IGatsbyImageData>();

  productImage.current = useCartImage(currentProduct);

  const handleOnChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { changeProductQuantity } = props;
    currentProduct.quantity = e.target && +e.target.value;
    changeProductQuantity(currentProduct);
  };

  return (
    <S.ProductInfo data-testid="cart-product">
      <S.ItemDetailsWrapper>
        <S.ProductImage>
          {productImage && productImage.current ? (
            <GatsbyImage
              image={productImage.current}
              alt={`${currentProduct.product_name} box`}
            />
          ) : (
            <S.ImgPlaceholder>Image Not Found</S.ImgPlaceholder>
          )}
        </S.ProductImage>
        <S.ItemDetails>
          {currentProduct.product_name}
          <S.Bottom className="desc">
            <S.RemoveBtn
              data-testid="remove-cart-item"
              onClick={() => removeProduct(currentProduct)}
            >
              Remove
            </S.RemoveBtn>
            <S.SelectQuantity>
              <select
                data-testid="cart-item-quantity"
                onChange={handleOnChange}
                value={currentProduct.quantity}
              >
                {Array.from(Array(99).keys()).map((i) => {
                  i += 1;
                  return (
                    <option key={i.toString()} value={i}>
                      {i}
                    </option>
                  );
                })}
              </select>
            </S.SelectQuantity>
            {currentProduct.base_price ? (
              <S.ItemPrice data-testid="cart-item-price">
                ${formatPrice(+currentProduct.base_price)}
              </S.ItemPrice>
            ) : null}
          </S.Bottom>
        </S.ItemDetails>
      </S.ItemDetailsWrapper>
      {currentProduct.is_subscription ? (
        <S.ItemSubscription>
          ${currentProduct.amount} / {currentProduct.subscription_frequency}
        </S.ItemSubscription>
      ) : null}
    </S.ProductInfo>
  );
};

export default CartProduct;
